import { Link } from "react-router-dom";
import { CONTACT } from "@/lib/api";
import { useI18n } from "@/lib/i18n";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer
      className="bg-black border-t border-white/5 mt-32 pt-20 pb-10 px-6 md:px-12"
      data-testid="footer"
    >
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="label-luxury mb-3">ESCORT AGENCY · ATHENS · VIP MODELS</div>
          <h3 className="font-serif-display text-3xl md:text-4xl tracking-[0.15em] uppercase leading-tight mb-2 gold-text font-semibold">
            Bilion Euro Babies
          </h3>
          <div className="label-pink mb-5 text-[0.6rem]">Luxury Beyond Imagination</div>
          <p className="text-white/50 text-sm max-w-md leading-relaxed">
            {t("footer_text")}
          </p>
          <div className="mt-5 flex flex-wrap gap-3 text-[0.6rem] tracking-[0.3em] uppercase text-white/40">
            <span className="text-[var(--gold)]">Luxury</span>
            <span>·</span>
            <span className="text-[var(--pink)]">Pleasure</span>
            <span>·</span>
            <span className="text-[var(--gold)]">Power</span>
            <span>·</span>
            <span className="text-[var(--pink)]">Discretion</span>
          </div>
        </div>

        <div>
          <div className="label-luxury mb-5">{t("f_directory")}</div>
          <ul className="space-y-3 text-sm text-white/60">
            <li><Link to="/companions" className="hover-gold">{t("f_all")}</Link></li>
            <li><Link to="/services" className="hover-gold">{t("f_services")}</Link></li>
            <li><Link to="/reviews" className="hover-gold">{t("f_reviews")}</Link></li>
            <li><Link to="/contact" className="hover-gold">{t("f_booking")}</Link></li>
          </ul>
        </div>

        <div>
          <div className="label-luxury mb-5">{t("f_contact")}</div>
          <ul className="space-y-3 text-sm text-white/60">
            <li>
              <a href={`tel:${CONTACT.phone}`} className="hover-gold">
                {CONTACT.display}
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${CONTACT.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                className="hover-gold"
              >
                WhatsApp
              </a>
            </li>
            <li>
              <a
                href={`viber://chat?number=%2B${CONTACT.viber}`}
                className="hover-gold"
              >
                Viber
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="hover-gold">
                {CONTACT.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-white/30 text-xs tracking-widest uppercase">
          © {new Date().getFullYear()} Bilion Euro Babies · {t("f_rights")}
        </p>
        <p className="text-white/30 text-xs tracking-widest uppercase">
          {t("f_location")}
        </p>
      </div>
    </footer>
  );
}
